import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "../styles/home.scss";
import { backend } from "../../../components/apipath";

function Careerarea() {
  const [careerData, setCareerData] = useState([]);

  useEffect(() => {
    fetchCareerArticles();
  }, []);

  const fetchCareerArticles = async () => {
    try {
      const res = await axios.get(`${backend}home/careerArticles`);
      setCareerData(res.data || []);
    } catch (err) {
      console.error("Error fetching career articles:", err);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return "";
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}.${mm}.${dd}`;
  };

  return (
    <div className="container">
      <div className="row">
        <div className="newtitle">職涯專欄</div>

        <div className="tabcontent row">
          <div className="col-12">
            {careerData.length === 0 ? (
              <div className="text-muted py-5 text-center">目前沒有資料</div>
            ) : (
              <div className="row g-4">
                {careerData.map((item, index) => {
                  const cover = item.cover_1 || "/images/400.png";
                  const dateText = formatDate(item.create_date);
                  const link = item.link ? item.link : `/home/newdetail/${item.new_id}`;
                  const isExternal = Boolean(item.link);

                  const CardInner = (
                    <div className="newbox h-100">
                      <div className="newbox-imgwrap">
                        <img src={cover} alt={item.title} />
                      </div>

                      <div className="newmain">
                        <h2 className="line-2">{item.title}</h2>

                        {dateText && (
                          <span className="newdate">{dateText}</span>
                        )}

                        {item.intro && (
                          <p
                            className="line-2"
                            dangerouslySetInnerHTML={{
                              __html: item.intro || "",
                            }}
                          />
                        )}

                        <span className="lm">MORE</span>
                      </div>
                    </div>
                  );

                  return (
                    <div
                      className="col-12 col-md-6 col-xl-4"
                      key={item.new_id || index}
                    >
                      {isExternal ? (
                        <a
                          href={link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-decoration-none text-reset d-block h-100"
                        >
                          {CardInner}
                        </a>
                      ) : (
                        <Link
                          to={link}
                          className="text-decoration-none text-reset d-block h-100"
                        >
                          {CardInner}
                        </Link>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Careerarea;